/**
 * Created by Administrador on 17/11/2017.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('ssrCtrl', ssrCtrl)
        .controller('newEditSsrCtrl', newEditSsrCtrl);


    ssrCtrl.$inject = ['linkService', 'tabs','items'];

    newEditSsrCtrl.$inject = ['tabs', 'ssrService', 'linkService', 'subClassificationService','item','action', 'classifications'];


    function ssrCtrl(linkService, tabs, items/*, fareItems*/){
        var vm = this;
        vm.linkService = linkService;
        vm.tabs = tabs;
        vm.pages = items.data.page;
        vm.items = (items.data._embedded) ? items.data._embedded.ssrs : [];

        vm.linkService = linkService;
    }

    function newEditSsrCtrl(tabs, ssrService, linkService, subClassificationService, item, action,classifications){
        var vm = this;
        vm.tabs = tabs;
        vm.linkService = linkService;
        vm.item = {
            rbcFareItem: {
                percentage: 0,
                fixedAmount: 0,
                baseTariff: true,
                itemId: 0
            }
        };

        vm.measuringUnitJson = ['UNITS_OF_CAPACITY', 'UNITS_OF_DENSITY', 'UNITS_OF_ENERGY', 'UNITS_OF_FORCE', 'UNITS_OF_LENGTH', 'UNITS_OF_MASS', 'UNITS_OF_SPECIFIC_WEIGHT', 'UNITS_OF_POWER'];

        vm.priceCalculationJson= ['BAGGAGE_RATE', 'PASSAGE_RATE', 'CARGO_RATE', 'NO_COST'];

        vm.classifications = (classifications.data._embedded) ? classifications.data._embedded.ssrClassifications : [];

        if(action == 'edit') {
            vm.item.name = item.data.name;
            vm.item.description = item.data.description;
            vm.item.withRank = item.data.withRank;
            vm.item.measuringUnit = item.data.measuringUnit;
            vm.item.priceCalculation = item.data.priceCalculation;
            vm.item.percentage = item.data.percentage;
            vm.item.fixedAmount = item.data.fixedAmount;

            vm.range = false;
            if(item.data.withRank) {
                vm.range = true;
                vm.item.minor = item.data.minor;
                vm.item.maximum = item.data.maximum;
            } else {
                vm.item.minor = 0;
                vm.item.maximum = 0;
            }
            vm.item.itemId = vm.linkService.getLinkId(item.data._links.self.href);
        }

        vm.saveSsr = function(isValid, item){
            if (isValid) {
                if(action === "new"){
                    ssrService.saveSsr(item);
                }else{
                    ssrService.updateSsr(vm.item.itemId, vm.item)
                }
            }
        };

        vm.onChangeRange = function(opt) {
            var vm = this;
            vm.range = false;
            if(opt == 1) {
                vm.range = true;
            } else {
                if(vm.item.minor ===0) {
                    vm.item.minor = 0;
                }
                if(vm.item.maximum ===0) {
                    vm.item.maximum = 0;
                }
            }
        }

        vm.setPriceCalculation = function (priceCalculation){
            if(priceCalculation != undefined) {
                if(priceCalculation !== 'BAGGAGE_RATE') {
                    vm.item.percentage = 0;
                    vm.item.fixedAmount = 0;
                }
            }
        }
    }
})();
